// ---------------------------------------------------------------------------
// Default cost info
// ---------------------------------------------------------------------------
const DEFAULT_COST = {
    model_used: 'gpt-4o',
    input_tokens: 150,
    output_tokens: 80,
    estimated_cost_usd: 0.002,
    tool_calls_count: 1
};
// ---------------------------------------------------------------------------
// Factory Functions
// ---------------------------------------------------------------------------
export function makeStreamStart(responseId, conversationId, agent, turnNumber = 1, delayMs = 500) {
    return {
        type: 'stream_start',
        payload: { response_id: responseId, conversation_id: conversationId, turn_number: turnNumber, agent },
        delayMs
    };
}
export function makeBlockStart(blockId, blockIndex, blockType, delayMs = 500) {
    return {
        type: 'block_start',
        payload: { block_id: blockId, block_index: blockIndex, block_type: blockType },
        delayMs
    };
}
export function makeTextDelta(blockId, text, delayMs = 100) {
    const delta = { kind: 'text', text };
    return {
        type: 'block_delta',
        payload: { block_id: blockId, delta },
        delayMs
    };
}
export function makeStepDelta(blockId, step, delayMs = 200) {
    const delta = { kind: 'step', step };
    return {
        type: 'block_delta',
        payload: { block_id: blockId, delta },
        delayMs
    };
}
export function makeBlockEnd(blockId, delayMs = 500) {
    return {
        type: 'block_end',
        payload: { block_id: blockId },
        delayMs
    };
}
export function makeBlockComplete(block, delayMs = 500) {
    return {
        type: 'block_complete',
        payload: { block_id: block.block_id, block_index: block.block_index, block },
        delayMs
    };
}
export function makeStreamEnd(responseId, totalBlocks, agent, delayMs = 500, cost = DEFAULT_COST) {
    return {
        type: 'stream_end',
        payload: {
            response_id: responseId,
            total_blocks: totalBlocks,
            cost,
            duration_ms: 2400,
            agent,
            feedback_id: `fb-${responseId}`
        },
        delayMs
    };
}
export function makeApprovalRequired(confirmation, delayMs = 500) {
    const approvalId = confirmation.type === 'confirmation' ? confirmation.approval_id : confirmation.plan_id;
    const threadId = confirmation.type === 'confirmation' ? confirmation.thread_id : `thread-${confirmation.plan_id}`;
    return {
        type: 'approval_required',
        payload: {
            approval_id: approvalId,
            thread_id: threadId,
            confirmation
        },
        delayMs
    };
}
// New-conversation nudge (ipa-training-mode). Cross-repo Nudge Contract v1.
export function makeNudge(nudgeId, message, nudgeType = 'new_conversation', reason = 'topic_shift', delayMs = 500) {
    return {
        type: 'nudge',
        payload: { nudge_id: nudgeId, nudge_type: nudgeType, reason, message },
        delayMs
    };
}
export function makePlanProgress(payload, delayMs = 300) {
    return {
        type: 'plan_progress',
        payload,
        delayMs
    };
}
export function makeProgress(phase, message, agent, delayMs = 300) {
    return {
        type: 'progress',
        payload: { phase, message, agent },
        delayMs
    };
}
export function makeThoughtProgress(phase, thoughtKey, agent, detail, delayMs = 300) {
    return {
        type: 'progress',
        payload: { phase, thought_key: thoughtKey, detail, agent },
        delayMs
    };
}
// ---------------------------------------------------------------------------
// Helper: split text into streaming chunks
// ---------------------------------------------------------------------------
export function splitTextIntoDeltas(blockId, text, chunkSize = 15, delayMs = 100) {
    const events = [];
    for (let i = 0; i < text.length; i += chunkSize) {
        events.push(makeTextDelta(blockId, text.slice(i, i + chunkSize), delayMs));
    }
    return events;
}
